export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-de-DE.6edde093.xlsx";